import MoreVertIcon from '@mui/icons-material/MoreVert';
import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import { Button, Menu, MenuItem } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import DeleteIcon from '@mui/icons-material/Delete';
import propsType from 'prop-types';

const StyledMenu = styled((props) => (
   <Menu
      elevation={0}
      anchorOrigin={{
         vertical: 'bottom',
         horizontal: 'right',
      }}
      transformOrigin={{
         vertical: 'top',
         horizontal: 'right',
      }}
      {...props}
   />
))(({ theme }) => ({
   '& .MuiPaper-root': {
      borderRadius: 6,
      marginTop: theme.spacing(1),
      minWidth: 180,
      color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
      boxShadow:
         'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
      '& .MuiMenu-list': {
         padding: '4px 0',
      },
      '& .MuiMenuItem-root': {
         '& .MuiSvgIcon-root': {
            fontSize: 18,
            color: theme.palette.text.secondary,
            marginRight: theme.spacing(1.5),
         },
         '&:active': {
            backgroundColor: alpha(
               theme.palette.primary.main,
               theme.palette.action.selectedOpacity,
            ),
         },
      },
   },
}));

function CustomizedMenus(props) {
   const [anchorEl, setAnchorEl] = React.useState(null);
   const open = Boolean(anchorEl);

   const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
   };
   const handleClose = () => {
      setAnchorEl(null);
   };

   const handleEditClick = () => {
      handleClose();
      props.handleEdit?.();
   };

   const handleDeleteClick = () => {
      handleClose();
      props.handleDelete?.();
   };

   return (
      <div>
         <Button
            id="demo-customized-button"
            aria-controls={open ? 'demo-customized-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            sx={{
               backgroundColor: '#333',
               color: '#fff',
               borderRadius: '50%',
               height: 32,
               width: 32,
               minWidth: 32,
            }}
         >
            <MoreVertIcon />
         </Button>
         <StyledMenu
            id="demo-customized-menu"
            MenuListProps={{
               'aria-labelledby': 'demo-customized-button',
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
         >
            <MenuItem onClick={handleEditClick} disableRipple disabled={!props?.canEdit}>
               <EditIcon />
               Edit
            </MenuItem>

            {props.isRolePermissionModule && (
               <MenuItem onClick={props.handleView} disableRipple>
                  <RemoveRedEyeIcon />
                  View
               </MenuItem>
            )}

            <MenuItem onClick={handleDeleteClick} disableRipple disabled={!props?.canDelete}>
               <DeleteIcon />
               Delete
            </MenuItem>
         </StyledMenu>
      </div>
   );
}

CustomizedMenus.propTypes = {
   handleView: propsType.func,
   handleEdit: propsType.func,
   handleDelete: propsType.func,
};

export default CustomizedMenus;
